/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const BarChartHorizontalBig = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 3v18h18" }],
    ["rect", { width: "12", height: "4", x: "7", y: "5", rx: "1" }],
    ["rect", { width: "7", height: "4", x: "7", y: "13", rx: "1" }]
  ]
];

export { BarChartHorizontalBig as default };
//# sourceMappingURL=bar-chart-horizontal-big.js.map
